export default __webpack_public_path__ + "static/media/directmartImage.b0211479.png";